import React from 'react';
import { PILOT_URL } from '../constants';
import { useTranslation } from 'src/i18n/shim/useTranslation';
import styles from './LandingNavContent.module.scss';

const LandingNavContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <nav aria-label={t('landing-nav-aria')} className={styles.navLinks}>
        <a href="#features">{t('landing-nav-features')}</a>
        <a href="#who">{t('landing-nav-who')}</a>
        <a href="#roadmap">{t('landing-nav-roadmap')}</a>
        <a href="#ast-vs-langhub">{t('landing-comparison-heading')}</a>
      </nav>
      <a
        className={styles.onboardBtn}
        href={PILOT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('landing-nav-join-pilot-aria')}
      >
        {t('landing-nav-join-pilot')}
      </a>
    </>
  );
};

export default LandingNavContent;
